export default "__VITE_ASSET__Kp8sU6TZ__"